import { defineStore, storeToRefs } from 'pinia';
import { Logger } from '@/services/logger';
import { fetchCMPData } from '@/api/bff';
import { useTrackingStore } from './tracking';

export const useRootStore = defineStore('root', () => {
  const { userTrackingConsents } = storeToRefs(useTrackingStore());

  async function getCMPData() {
    try {
      const result = await fetchCMPData();

      if (result) {
        const { trackingConsents } = result;

        userTrackingConsents.value = trackingConsents || null;
      }
    } catch (err) {
      Logger.logError('Fetching CMP data failed');
    }
  }

  return {
    getCMPData,
  };
});
